<template lang="pug">
section.col.form-passport(v-if="value")
  .row
    .col
      .label Имя
      input.input(v-model="value.first_name")
    .col
      .label Фамилия
      input.input(v-model="value.last_name")
    .col
      .label Отчество
      input.input(v-model="value.middle_name")
  .row
    .col
      .label Национальность
      input.input(v-model="value.nationality")
    .col
      .label Адрес
      input.input(v-model="value.address")
  .row
    .col
      .label Идентификационный номер
      input.input(v-model="value.identity_nubmer")
    .col
      .label Серия и номер
      input.input(v-model="value.nubmer")
  .row
    .col
      .label Тип документа
      input.input(v-model="value.type")
    .col
      .label Дата выдачи
      input.input(v-model="value.issue_date")
  .row
    .col
      .label Место выдачи
      input.input(v-model="value.issue_place")
    .col
      .label Действителен до
      input.input(v-model="value.valid_date")
  .row
    .col
      .label Пол
      input.input(v-model="value.sex")
</template>

<script>
export default {
  name: 'PassportForm',
  props: {
    value: {
      type: Object,
      default: () => (null),
      required: false,
    },
  },
};
</script>

<style lang="scss">
.form-address, .form-passport {
  position: relative;
  .preloader {
    height: 100%;
    width: 100%;
    position: absolute;
    background: #fff;
    opacity: .5;
  }
  .row {
    max-width: 400px;
    display: flex;
    .col {
      width: 100%;
      .label {
        font-size: 12px;
        font-weight: 600;
        padding-bottom: 1rem;
      }
      .input {
        width: 100%;
        padding-left: 1rem;
        height: 40px;
        font-size: 14px;
        margin-bottom: 1.5rem;
        border: 1px solid #ddd;
      }
      select {
        background: #fff;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        padding-left: 1rem;
        border-radius: 0;
      }
      & + .col {
        margin-left: 1rem;
      }
    }
    label {
      font-size: 12px;
      font-weight: 600;
    }
  }
}
</style>
